export default __webpack_public_path__ + "static/media/banner-title.728e3a74.png";